import * as React from "react";
import SupportContent from "../RevampHeader/SupportContent";
import { useEffect, useState } from "react";
const Support = () => {
    const [show, setShow] = useState(false);
    const wrapperRef = React.useRef(null);
    function toggleShow() {
        setShow(!show);
    }
    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShow(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { className: "support", onClick: toggleShow },
            React.createElement("i", { className: "edel-icon-support" })),
        show && (React.createElement(React.Fragment, null,
            React.createElement("div", { ref: wrapperRef },
                React.createElement(SupportContent, null))))));
};
export default Support;
